import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';

interface BookingHintProps {
  variant?: 'default' | 'compact';
  className?: string;
}

const BookingHint: React.FC<BookingHintProps> = ({ variant = 'default', className = '' }) => {
  const { t } = useTranslation();

  if (variant === 'compact') {
    return (
      <p className={`text-sm text-muted-foreground ${className}`}>
        {t('booking.paymentHint')}
      </p>
    );
  }

  return (
    <div className={`flex items-start gap-3 p-4 bg-purple-500/10 border border-purple-500/20 rounded-lg ${className}`}>
      <Info className="h-5 w-5 text-purple-500 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-purple-600 dark:text-purple-400">
        {t('booking.paymentHint')}
      </div>
    </div>
  );
};

export default BookingHint;
